<template>
  <auth-template>
    <login-poster slot="poster" />

    <template slot="information">
      <p>{{ $t('quiсk.and.free.registration') }}</p>
      <p>{{ $t('momentaly.activation.simple.integration') }}</p>
      <p>{{ $t('start.to.receive.transfers') }}</p>
    </template>

    <div :class="$style.container">
      <div :class="$style.header">
        <auth-header :title="$t('time.to.harvest')" />
      </div>

      <div :class="$style.form">
        <login-form :loading="loading" @submit="handleSubmit" />
      </div>

      <div :class="$style.registration">
        <p>{{ $t('not.registered.yet') }}</p>
        <p><router-link to="registration" data-test="loginRouterLink">{{ $t('common.registration') }}</router-link></p>
      </div>
    </div>
  </auth-template>
</template>

<script>
import LoginPoster from 'molecules/auth/LoginPoster';
import LoginForm from 'organisms/auth/LoginForm';
import AuthHeader from 'organisms/auth/AuthHeader';
import AuthTemplate from 'templates/AuthTemplate';

import AuthService from '@/services/auth';
import HTTPService from '@/services/Http';

import { TELEGRAM_BOT_LINK } from 'root/.env';

export default {
  name: 'LoginView',
  components: {
    LoginPoster,
    LoginForm,
    AuthHeader,
    AuthTemplate,
  },
  head: {
    title: {
      inner: 'Авторизация',
    },
    meta: [
      { name: 'description', content: 'Авторизация в Capusta.Space. Принимай деньги с любыми целями. Делаешь сайт, продаёшь в Instagram, собираешь инвестиции или фрилансишь — монетизируй образ жизни вместе с Capusta.Space! Легко, молниеносно, безопасно.', id: 'desc' },
    ],
    script: [
      {
        inner: '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");ym(56244937, "init", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});',
        type: 'text/javascript',
      },
      {
        inner: '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","GTM-WKBLDC4");',
        type: 'text/javascript',
      },
    ],
    noscript: [
      {
        inner: '<div><img src="https://mc.yandex.ru/watch/56244937" style="position:absolute; left:-9999px;" alt="" /></div>"/>',
      },
      {
        inner: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WKBLDC4" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
      },
    ],
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleSubmit(payload) {
      this.loading = true;

      // TODO: @danealton переработать сервис авторизации
      try {
        const data = await AuthService.login({
          username: payload.username,
          password: payload.password,
        });

        if (data.status && data.status === 'PENDING') {
          localStorage.setItem('token', data.socketAuthToken);
          this.$router.push({ name: 'TwoFactorAuth' });
          return;
        }

        if (localStorage.getItem('redirect')) {
          this.$router.push(localStorage.getItem('redirect'));
        } else {
          this.$router.push({ name: 'cabinet' });
        }

        const botBinding = JSON.parse(localStorage.getItem('botBinding'));

        if (this.$validate.isNotNull(botBinding)) {
          HTTPService.telegramBotBind()
            .then(() => {
              this.$alert({
                type: 'success',
                text: this.$t('telegram.bot.connected'),
              });

              window.open(TELEGRAM_BOT_LINK, '_blank');
            })
            .catch(() => {
              this.$alert({
                type: 'warning',
                text: this.$t('telegram.bot.not.connected'),
              });
            })
            .finally(() => {
              localStorage.removeItem('botBinding');
            });
        }
      } catch (error) {
        const { data } = error;

        switch (data.status) {
          case 'BLOCKED':
            this.$router.push({
              name: 'TwoFactorAuth',
              params: { result: 'blocked' },
            });
            break;
          case 'INACTIVE':
            this.$alert({
              type: 'warning',
              text: this.$t('failed.contact.the.support'),
            });
            break;
          default:
            this.$alert({
              type: 'warning',
              text: this.$t('something.not.right.check.login.or.password'),
            });
            break;
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

    &:after
      content: ''
      width: 745px
      height: 745px
      position: absolute
      left: 50%
      bottom: -54px
      transform: translateX(-50%)
      background: linear-gradient(249.76deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)
      border-radius: 50%
      z-index: -1

      +respond-to('small')
        width: 1085px
        height: 1085px
        bottom: -196px

      +respond-to('medium')
        width: 2200px
        height: 2200px
        top: 50%
        right: 0
        bottom auto
        left: -90px
        transform: translateY(-50%) rotate(180deg)
        background: linear-gradient(249.76deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)

  .header
    margin-bottom: 20px

    +respond-to('small')
      margin-bottom: 50px

  .form
    margin-bottom: 20px

  .registration
    margin-bottom: 90px

    +respond-to('small')
      margin-bottom: 246px
      display: flex

    +respond-to('medium')
      margin-bottom: 0

    p, a
      +base-text
      color: #fff

    p
      margin: 0 0 5px

      +respond-to('small')
        margin: 0 5px 0 0

    a
      text-decoration: underline
</style>
